export default {"src":"/_next/static/media/access_denied.6631d1ef.svg","height":64,"width":86};